

import React, { useState } from "react"
import { WithThor } from "@sl/react-thor"

const TrackingConfig = ({ children }) => {
  const [consent, setConsent] = useState<boolean>(false)

    const isUserGiveConsent = (): boolean => {
        if (typeof window !== "undefined") {
            const windowScope: any = window
            if (windowScope.UC_UI) {
                return windowScope.UC_UI.areAllConsentsAccepted()
            }
        }
        return false
    }

  const userConsentInterval = setInterval(() => {
    if (isUserGiveConsent()) { 
        setConsent(true);
        clearInterval(userConsentInterval);
    }
  }, 1000);

    return (
      <>
        <WithThor userConsent={consent} devMode compatibilities={{ GA4: true }}>
          {children}
        </WithThor>
      </>
    )
}

export default TrackingConfig